<script setup lang="ts">
import { useFetch } from '#app/composables/fetch';

withDefaults(
  // NOTE: レシピレイアウトで使用する場合はタイトル部分の見た目が微妙に違う
  // FIXME: このために処理が増えてるので、できれば統一したい
  defineProps<{
    titleStyle?: 'default' | 'recipe';
  }>(),
  {
    titleStyle: 'default',
  },
);

const { data: recipes } = await useFetch('/api/kiwi_user/recipes/latest');
</script>

<template>
  <div class="bg-white border border-b-2 border-cream-400 rounded">
    <h2
      v-if="titleStyle === 'default'"
      class="py-3 px-4 font-bold bg-cream-300 border-b border-b-cream-400 mb-4"
    >
      新着レシピ
    </h2>
    <h2 v-else class="px-5 pt-4 pb-2 font-bold text-xl text-brown-300">
      新着レシピ
    </h2>

    <ul class="px-5 grid grid-cols-2 md:grid-cols-3 gap-3 items-stretch mb-3">
      <li v-for="recipe in recipes" :key="recipe.old_identifier" class="h-full">
        <AtomsRecipeCard
          :old-identifier="recipe.old_identifier"
          :recipe-id="recipe.id"
          :filename="recipe.main_image"
          :energy="recipe.energy"
          :title="recipe.title"
          :tags="recipe.picked_recipe_tags"
        />
      </li>
    </ul>

    <div class="text-right pb-3 px-4">
      <NuxtLink
        to="/public/article/recipe/?order=rank"
        class="text-brown-300 text-lg"
        >すべてのレシピを見る</NuxtLink
      >
    </div>
  </div>
</template>
